define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {

	return declare(Widget, {

		SUBTYPE: "Subtype",

		/**
		 * @override
		 * Update Subtype field visibility
		 */
		_updateFieldVisibility: function(field) {
			this.inherited(arguments);
			// If Subtype field is on the form, disable it for copy action
			if (this.isCopy()) {
				this.setFieldDisabled(this.SUBTYPE, true);
			}

			return true;
		}
	});
});